export default [
    { weekDay: 0, slug: 'sunday', title: 'Domingo' },
    { weekDay: 1, slug: 'monday', title: 'Segunda' },
    { weekDay: 2, slug: 'tuesday', title: 'Terça' },
    { weekDay: 3, slug: 'wednesday', title: 'Quarta' },
    { weekDay: 4, slug: 'thursday', title: 'Quinta' },
    { weekDay: 5, slug: 'friday', title: 'Sexta' },
    { weekDay: 6, slug: 'saturday', title: 'Sábado' },
]